import SubmissionModel from "@/models/lab/SubmissionModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class SubmissionCollection extends LabServiceCollection {
  model() {
    return SubmissionModel;
  }

}
